import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  triageDetails: [],
  failureDescriptiveText: ""
};

const troubleshootingReducer = createSlice({
  name: "troubleshoot",
  initialState,
  reducers: {
    resetStore() {
      return initialState;
    },
    setTroubleshootAnswer(state, action) {
      const { key, value } = action.payload;
      state[key] = value;
      state.triageDetails = [action.payload, ...state.triageDetails] 
    },
    setfailureDescriptiveText(state, action) {
      state.failureDescriptiveText = action.payload
    },
  },
});

const { actions, reducer } = troubleshootingReducer;
export const { resetStore, setTroubleshootAnswer, setfailureDescriptiveText } = actions;
export default reducer;
